import script from "./productsAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./productsAdd.vue?vue&type=script&setup=true&lang=js"

import "./productsAdd.vue?vue&type=style&index=0&id=37c4bdd6&lang=css"
import "./productsAdd.vue?vue&type=style&index=1&id=37c4bdd6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37c4bdd6"]])

export default __exports__